import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";

import { Drawer, Text } from "@mantine/core";

import Filters from '../settings/Filters';

import { setTiptapSidemenu } from '../../../store/app';

export default function FilterMembersModal() {
  const dispatch = useDispatch();

  const tiptapSidemenu = useSelector((state) => state.tiptapSidemenu);

  const [opened, setOpened] = useState(false);
  const [slug, setSlug] = useState(null);

  useEffect(() => {
    if (tiptapSidemenu && tiptapSidemenu.opened == "filter-members") {
      setSlug(tiptapSidemenu.option);
      setOpened(true);
    } else if (tiptapSidemenu && tiptapSidemenu.opened == "filter-members-close") {
      setSlug(null);
      setOpened(false);
    }
  }, [tiptapSidemenu]);

  useEffect(() => {
    if (!opened) {
      setSlug(null);
      if (tiptapSidemenu.opened == "filter-members") {
        dispatch(setTiptapSidemenu({ opened: "filter-members-close" }));
      }
    }
  }, [opened]);

  return (
    <Drawer
      title={
        <Text weight="bold">
          Member properties
        </Text>
      }
      padding="md"
      size="lg"
      zIndex={5000}
      opened={opened}
      onClose={() => setOpened(false)}
    >
      {!!slug && <Filters slug={slug} type="filter-members" />}
    </Drawer>
  );
}
